// src/api/subscriptionApi.js
import axiosInstance from "./axiosInstance";

// GET: all active plans (for logged-in user)
export const fetchPlansApi = () => {
  return axiosInstance.get("/api/subscription/plans");
};

// GET: current user's active subscription
export const fetchMySubscriptionApi = () => {
  return axiosInstance.get("/api/subscription/my");
};

// POST: purchase a subscription plan
export const purchaseSubscriptionApi = (data) => {
  return axiosInstance.post("/api/subscription/purchase", data);
};

// support ticketing apis

export const getSupportCategoriesApi = () => {
  return axiosInstance.get("/api/support/categories");
};

export const createSupportTicketApi = (formData) => {
  return axiosInstance.post("/api/support/create-ticket", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getMySupportTicketsApi = () => {
  return axiosInstance.get("/api/support/my-ticket");
};

export const fetchSupportContactApi = (payload) => {
  return axiosInstance.post("/api/support/contacts", payload);
};

// CMS PAGES APIS can be added here as needed
export const getCmsPageApi = (key) => {
  return axiosInstance.get(`/api/cms/${key}`);
};


export default {
  fetchPlansApi,
  fetchMySubscriptionApi,
  purchaseSubscriptionApi,
  getSupportCategoriesApi,
  createSupportTicketApi,
  getMySupportTicketsApi,
  fetchSupportContactApi,
  getCmsPageApi,
};
